<div class="toolbar-section" id="mobileMenu">

  <nav class="slideable-menu mt-4">
    <ul class="menu">
      <li class="has-children" *ngFor="let menu of menuService.items">
        <span>
          <a [routerLink]="menu.route">
            <i class="fa fa-{{iconFor(menu)}} menu-ico" aria-hidden="true"></i>
            <span>{{menu.text  | translate}}</span>
          </a>
          <span class="sub-menu-toggle" *ngIf="menu.submenu" id="menu-{{menu.text}}"></span>
        </span>
        <ul class="slideable-submenu" *ngIf="menu.submenu" id="menu-{{menu.text}}">
          <li class="back-btn">
            <a href="#back">Back</a>
          </li>
          <li *ngFor="let sMenu of menu.submenu" routerLinkActive='active' (click)="reDirect()">
            <a href="#menu-{{sMenu}}" routerLink="/app/{{sMenu.route}}">
              <i class="fa fa-{{iconFor(sMenu)}} menu-ico" aria-hidden="true"></i>
              <span>{{sMenu.text  | translate}}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</div>